module.exports = __webpack_public_path__ + "img/feature_buy_zh.e8b41390.png";